import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'modules/auth/contexts/AuthContext';

const Redirector = () => {

    const { user, loading, isAuthenticated, effectiveRole } = useAuth();

    // ================= LOADING =================
    if (loading) return null;

    // ================= NOT AUTHENTICATED =================
    if (!isAuthenticated || !user) {
        return <Navigate to="/login" replace />;
    }

    // ================= FORCE PASSWORD =================
    if (user.force_password_change === true && !localStorage.getItem('password_changed_after_reset')) {
        return <Navigate to="/change-password" replace />;
    }

    // ================= ROLE NORMALIZATION =================
    // Redirect by effective (base) role so custom roles land on the right home.
    const role = String(
        effectiveRole ||
        user.role_name ||
        user.role ||
        ''
    ).toUpperCase();

    // ================= ROLE BASED REDIRECT =================
    if (['ADMIN', 'SUPER_ADMIN'].includes(role)) {
        return <Navigate to="/admin/dashboard" replace />;
    }

    if (role === 'EMPLOYEE') {
        return <Navigate to="/employee/dashboard" replace />;
    }

    // ================= FALLBACK =================
    return <Navigate to="/login" replace />;
};

export default Redirector;